module.exports = __webpack_public_path__ + "img/dynamicOpen.014ac221.png";